import { Subject } from 'rxjs/Subject';
import { COLORS } from '../../../shared/colors';
export var SnackbarType;
(function (SnackbarType) {
    SnackbarType[SnackbarType["INFORMATION"] = 0] = "INFORMATION";
    SnackbarType[SnackbarType["SUCCESS"] = 1] = "SUCCESS";
    SnackbarType[SnackbarType["WARNING"] = 2] = "WARNING";
    SnackbarType[SnackbarType["ERROR"] = 3] = "ERROR";
})(SnackbarType || (SnackbarType = {}));
var SnackbarService = (function () {
    function SnackbarService() {
        this.snackbarQueue = [];
        this._snackbarOptions = new Subject();
        this.snackbarOptionsObservable = this._snackbarOptions.asObservable();
    }
    /**
     * Adds a snackbar message to queue
     * @param {SnackbarType} type      SnackbarType (INFORMATION, SUCCESS, WARNING, ERROR)
     * @param {string} message         Message that should be displayed
     * @param {number} [duration=3000] Duration of message display (optional)
     */
    SnackbarService.prototype.add = function (type, message, duration) {
        if (duration === void 0) { duration = 3000; }
        var snackbarOptions = {
            type: type,
            message: message,
            visible: false,
            duration: isNaN(duration) || duration <= 0 ? 3000 : duration,
            color: '',
            icon: '',
        };
        switch (snackbarOptions.type) {
            default:
            case SnackbarType.INFORMATION:
                snackbarOptions.color = COLORS.main.signalColorInfo.hex;
                snackbarOptions.icon = 'information';
                break;
            case SnackbarType.SUCCESS:
                snackbarOptions.color = COLORS.main.signalColorSuccess.hex;
                snackbarOptions.icon = 'success';
                break;
            case SnackbarType.WARNING:
                snackbarOptions.color = COLORS.main.signalColorWarning.hex;
                snackbarOptions.icon = 'warning';
                break;
            case SnackbarType.ERROR:
                snackbarOptions.color = COLORS.main.signalColorError.hex;
                snackbarOptions.icon = 'error';
                break;
        }
        this.snackbarQueue.push(snackbarOptions);
        if (this.snackbarQueue.length === 1) {
            this.openNextSnackbarItem();
        }
    };
    /**
     * Display next item in queue
     */
    SnackbarService.prototype.openNextSnackbarItem = function () {
        if (this.snackbarQueue.length > 0) {
            this.snackbarQueue[0]['visible'] = true;
            this._snackbarOptions.next(this.snackbarQueue[0]);
        }
    };
    /**
     * Dismiss message and trigger next item in queue
     */
    SnackbarService.prototype.dismiss = function () {
        var _this = this;
        this.snackbarQueue[0]['visible'] = false;
        this._snackbarOptions.next(this.snackbarQueue[0]);
        // Show next message after old one is hidden
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
            // Remove first element of queue
            _this.snackbarQueue.shift();
            _this.openNextSnackbarItem();
        }, 250);
    };
    return SnackbarService;
}());
export { SnackbarService };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/snackbar/snackbar.service.ts.pre-build-optimizer.js